"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ATCGroupBody = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const atc_group_body_style_1 = __importDefault(require("./atc.group.body.style"));
class ATCGroupBody extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.render = () => {
            const { classes, children, loading } = this.props;
            return (jsx_runtime_1.jsx("div", Object.assign({ className: classes.root, "aria-busy": loading, "data-cy": "atomic-atc-group-body" }, { children: jsx_runtime_1.jsx("div", Object.assign({ className: classes.body }, { children: jsx_runtime_1.jsx("div", Object.assign({ className: classes.content }, { children: children }), void 0) }), void 0) }), void 0));
        };
    }
}
exports.ATCGroupBody = ATCGroupBody;
ATCGroupBody.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    children: prop_types_1.default.node.isRequired,
    loading: prop_types_1.default.bool
};
ATCGroupBody.defaultProps = {
    loading: false
};
exports.default = react_jss_1.default(atc_group_body_style_1.default)(ATCGroupBody);
//# sourceMappingURL=atc.group.body.js.map